import { render, staticRenderFns } from "./ChartsTable.vue?vue&type=template&id=24e1c732&scoped=true&"
import script from "./ChartsTable.vue?vue&type=script&lang=js&"
export * from "./ChartsTable.vue?vue&type=script&lang=js&"
import style0 from "./ChartsTable.vue?vue&type=style&index=0&id=24e1c732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1c732",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VIcon})
